<template>
  <div v-show="news.items.length" class="news-load-footer" :class="{ 'end-reached': news.endReached }">
    <hr>
    <div
      class="content-box plausible-event-name=load+more+news+click"
      @click="onLoadMoreClick">
        {{label}}
    </div>
    <hr>
  </div>
</template>

<script>
import { EventBus } from '@/assets/js/helpers.js'
import LassoxLink from './LassoxLink.vue';

export default {
  name: 'NewsLoadFooter',
  components: {
    LassoxLink
  },
  props: {
    news: {
      type: Object,
      required: true
    },
    // Experimentally, the loading more news has been made a freemium feature. Feel free to delete all loading code if that experiment becomes permanent
    loading: {
      type: Boolean,
      required: true
    },
    feedType: {
      type: String,
      required: true
    },
  },
  data () {
    return {
    }
  },
  computed: {
    label: function () {
      return this.loading ? 'HENTER FLERE NYHEDER..' : this.news.endReached ? 'IKKE FLERE NYHEDER' : 'VIS FLERE NYHEDER'
    }
  },
  methods: {
    onLoadMoreClick: function () {
      EventBus.$emit('loadNews')
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) "~@oldShared/lasso/style/constants/colors";
  .news-load-footer {
    padding: 50px 0 0 0 !important;
    display: flex;
    align-items: center;
    width: 100%;
    hr {
      flex: 1;
      margin: 0;
      border-color: #e2e2e2;
    }
    div.content-box {
      border: 1px solid #e2e2e2;
      min-width: 320px;
      cursor: pointer;
      text-align: center;
      margin: 0 30px;
      font-weight: bold;
      font-size: 11px;
      line-height: 35px;
      color: @red-primary;
    }

    &.end-reached {
      div.content-box {
        border: none;
        cursor: auto;
        color: #777;
        &:hover {
          color: #777;
        }
      }
    }
  }

  #app.xxs {
    div.content-box {
      min-width: 200px;
    }
  }
</style>
